export default "__VITE_ASSET__DMlD68fR__"